import { useDispatch } from 'react-redux';
import { baseErrorHandler } from '@queries/baseErrorHandler';
import { showMessage } from '@queries/showMessage';
import { $api } from '@service/RequestService';
import { useMutation, useQueryClient } from 'react-query';
import { NumberParam, StringParam, useQueryParams, withDefault } from 'use-query-params';

import { offerConstants, setTrash } from '..';

export function useDeleteOffer() {
  const qc = useQueryClient();
  const dispatch = useDispatch();

  const [query] = useQueryParams({
    search: StringParam,
    page: withDefault(NumberParam, 1),
    size: withDefault(NumberParam, 10)
  });

  return useMutation(
    async (id?: number) => {
      const { data } = await $api.delete(`/v1/offer/${id}`);

      return data;
    },
    {
      onError: baseErrorHandler,
      onSuccess: async data => {
        await qc.invalidateQueries([offerConstants.queryKeys.OFFER, query]);

        showMessage(data?.message, data?.accept);

        dispatch(
          setTrash({
            visible: false
          })
        );
      }
    }
  );
}
